import { BASE_URL, getAxiosConfig } from "../components/interface/Config";
import { apiHandler } from "./authService";


export const fetchUserInfo = async () => {
  const authToken = sessionStorage.getItem("authToken");
  if (!authToken) {
    throw new Error("User is not authenticated. Please log in.");
  }

    const url = `${BASE_URL}/users/info`;
    const response   = await apiHandler('', 'GET', {}, url);

    if (!response) {
        throw new Error("No response received from the server");
    }

    const data = response.data;
    console.log('response', data);

  // const response = await fetch(`${BASE_URL}/users/info`, {
  //   method: "GET",
  //   headers: getAxiosConfig().headers,
  // });

  // if (!response.ok) {
  //   throw new Error("Error fetching user info");
  // }

  // const data = await response.json();
  // return data.data.is_2fa === 1;
  return data.data.is_2fa === 1;
};

export const updateTwoFactorAuth = async (is2FAEnabled: boolean) => {
  const authToken = sessionStorage.getItem("authToken");
  if (!authToken) {
    throw new Error("User is not authenticated. Please log in.");
  }

  const payload = { is_2fa: is2FAEnabled };

  const url = `${BASE_URL}/users/twofa`;
  const response   = await apiHandler('', 'PATCH', payload, url);

  if (!response) {
      throw new Error("No response received from the server");
  }

  // const response = await fetch(`${BASE_URL}/users/twofa`, {
  //   method: "PATCH",
  //   headers: getAxiosConfig().headers,
  //   body: JSON.stringify({ is_2fa: is2FAEnabled }),
  // });

  // if (!response.ok) {
  //   throw new Error("Error updating 2FA status");
  // }

  // return await response.json();
  return response;
};